module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modern-upload-field', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "value": _vm.value,
      "accept": ".mp3,audio/*",
      "required": _vm.required,
      "uploading": _vm.uploading,
      "has-error": _vm.hasError,
      "error-message": _vm.errorMessage,
      "hint": "Choose audio file (.mp3)"
    },
    on: {
      "file-selected": _vm.changeFileHandle
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69aafe6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/RaceMedia.vue
// module id = 1722
// module chunks = 2